import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import { Alert } from "reactstrap";
import CloneICON from "../../../assets/images/clone.svg";
// Require Editor CSS files.
import * as UTILS from "../../../utils/Utils";
import Popup from "../../Modal/Popup";
import TinyMCEHTMLEditor from "./TinyMCEHTMLEditor";
import "./Html.scss";
import CodeIcon from "./CodeIcon";

export const chatbotTest = /<div\s+[^>]*id="[^"]*chat[^"]*"[^>]*>/i;

class HTMLEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.content,
      id: null,
      prevContent: this.props.content, // Track previous content
      cancelFlag: false, // Flag to control handleModelChange execution
    };
    // Add a ref to track cancel state for immediate access
    this.cancelFlagRef = React.createRef();
    this.cancelFlagRef.current = false;
    // Add ref to store editor instance
    this.editorRef = React.createRef();
    
    this.handleModelChange = this.handleModelChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSaveContent = this.handleSaveContent.bind(this);
  }
  componentDidMount = () => { };

  setIdForEditHandler = (editID) => {
    // Store current content as previous content when opening editor
    this.setState({
      id: editID,
      prevContent: this.props.content,
      cancelFlag: false, // Reset cancel flag when opening editor
    });
    this.cancelFlagRef.current = false;
  };

  handleCancel = () => {
    // Restore the editor content to the original content
    if (this.editorRef.current) {
      this.editorRef.current.setContent(this.state.prevContent);
    }
    
    // Close the popup without saving any changes
    this.setIdForEditHandler(null);
  };

  handleModelChange = (model) => {
    const layout = this.props.layout;
    const idEdit = this.props.ID;
    //
    const newLayout = UTILS.UpdateLayout(
      layout,
      idEdit,
      (item) => {
        item.content = model;
      },
      (colItem) => {
        colItem.content = model;
      },
      (colItemNested) => {
        colItemNested.content = model;
      }
    );

    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  handleSaveContent = () => {
    // Get the current content from the editor
    if (this.editorRef.current) {
      const content = this.editorRef.current.getContent();
      
      function emojiToUnicode(text) {
        return text.replace(
          /([\u{1F600}-\u{1F64F}])|([\u{1F300}-\u{1F5FF}])|([\u{1F680}-\u{1F6FF}])|([\u{2600}-\u{26FF}])|([\u{2700}-\u{27BF}])|([\u{1F900}-\u{1F9FF}])|([\u{1F1E0}-\u{1F1FF}])/gu,
          (match) => {
            return (
              "&#x" +
              match
                .codePointAt(0)
                .toString(16)
                .toUpperCase()
                .padStart(4, "0")
            );
          }
        );
      }

      const encodedHTMLContent = emojiToUnicode(content);
      
      // Use the same logic as handleModelChange
      const layout = this.props.layout;
      const idEdit = this.props.ID;
      
      const newLayout = UTILS.UpdateLayout(
        layout,
        idEdit,
        (item) => {
          item.content = encodedHTMLContent;
        },
        (colItem) => {
          colItem.content = encodedHTMLContent;
        },
        (colItemNested) => {
          colItemNested.content = encodedHTMLContent;
        }
      );

      console.log("saving content to layout");
      this.props.layoutArray(this.props.layoutTitle, newLayout);
    }
    
    // Close the popup after saving
    this.setIdForEditHandler(null);
  };

  render() {
    return (
      <div className="html-wrapper">
        <div className="actionControl">
          <span className="image-setting" onClick={() => this.setIdForEditHandler(this.props.ID)}>HTML Editor</span>
          <button className="clone-item" onClick={() => { this.props.cloneElement(this.props.element.id) }}>
            <img src={CloneICON} />
          </button>
          <span className="delete-item" onClick={() => { this.props.deleteElement(this.props.element.id) }}>
            <i className="far fa-trash-alt" />
          </span>
        </div>
        <div className="tiny-html-container">
          <div
            className="htmlContent"
            onClick={() => this.setIdForEditHandler(this.props.ID)}
            style={{ fontFamily: this.props.fontFamily }}
            dangerouslySetInnerHTML={{ __html: this.props.content }}
          ></div>
        </div>
        {(!this.props.content || chatbotTest.test(this.props.content)) && (
          <>
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10
            }}>
              <CodeIcon content={this.props.content}
              onOpenSourceCode={() => this.setIdForEditHandler(this.props.ID)} 
              />
            </div>
            <div style={{ height: "120px" }}></div>
          </>
        )}


        {this.props.ID === this.state.id ? (
          <Popup
            width="1000"
            header="HTML Editor"
            closePopup={() => this.setIdForEditHandler(null)}
            close={() => this.setIdForEditHandler(null)}
            onCancel={this.handleCancel}
            onSave={this.handleSaveContent}
            parentID="HTMLWrap"
            htmlFooterButtons={true}
          >
            {/* <Alert color="secondary">
              <h1 className="errorBoundary">
                This version of the HTML editor is no longer supported in the
                Responsive Studio 2.0. While the previously generated content
                will still be rendered, the editing functionality has been
                removed. This element is now replaced with the Table Element and
                all other features are available through the already existing
                Text Element.
              </h1>
            
            </Alert> */}
            <TinyMCEHTMLEditor
              modalOpen={this.props.ID === this.state.id}
              pagesList={this.props.pagesList}
              ID={"f" + this.props.ID}
              content={this.props.content}
              elementsFont={this.props.elementsFont}
              selectedFont={this.props.selectedFont}
              handleClosePopup={() => this.setIdForEditHandler(null)}
              handleCancel={this.handleCancel}
              onEditorChange={this.handleModelChange}
              preset={this.props.preset}
              ref={this.editorRef}
            />
          </Popup>
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    elementsFont: state.present.canvasStyle.elementsFont,
    preset: state.present.preset,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HTMLEditor);
